module.exports = __webpack_public_path__ + "static/media/e_1.90aa41ad.svg";